import { WebSocketReceiveMessage } from './web-socket-receive-message';

export class WebSocketReloadDisplay extends WebSocketReceiveMessage {
  public actionDelayInMs: number;
}
